import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Kontakt Seite - Digitale Visitenkarte
 * Dark Theme - Responsive für Desktop und Mobile
 */

const Kontakt = () => {
  const whatsappLink = "https://wa.me/4915233978878?text=Hallo%20Nico%2C%20ich%20habe%20deine%20Webseite%20besucht%20und%20würde%20mich%20gern%20bei%20dir%20melden.";

  // vCard Download Funktion
  const downloadVCard = () => {
    const vcard = `BEGIN:VCARD
VERSION:3.0
FN:Nico Helfrich
N:Helfrich;Nico;;;
TEL;TYPE=CELL:+4915233978878
EMAIL:kontakt@nicohelfrich.de
URL:https://nicohelfrich.de
END:VCARD`;
    
    const blob = new Blob([vcard], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Nico_Helfrich.vcf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div 
      className="min-h-screen"
      style={{ 
        background: '#0a0f1e',
        color: '#ffffff',
        fontFamily: '"Archivo", "Helvetica Neue", Arial, sans-serif'
      }}
    >
      {/* Desktop: Two Column Layout / Mobile: Single Column */}
      <main className="max-w-6xl mx-auto px-4 py-8 lg:py-16">
        <div className="flex flex-col lg:flex-row lg:gap-16 lg:items-start">
          
          {/* Left Column - Image (Desktop) / Top Section (Mobile) */}
          <div className="lg:w-1/2 lg:sticky lg:top-8">
            <figure 
              className="relative rounded-2xl overflow-hidden mx-auto lg:mx-0 max-h-[380px] lg:max-h-[480px]"
              style={{ 
                background: '#111829',
                maxWidth: '440px'
              }}
            >
              <img 
                src="https://customer-assets-gfyr7b9c.emergentagent.net/job_wealth-architect-12/artifacts/18906e692fb34eeb__JNW9777.webp"
                alt="Nico Helfrich"
                className="w-full h-auto"
              />
              {/* Gradient Overlay */}
              <div 
                className="absolute inset-x-0 bottom-0 pointer-events-none"
                style={{ 
                  height: '28%',
                  background: 'linear-gradient(180deg, rgba(10,15,30,0), rgba(10,15,30,.55))'
                }}
              />
              {/* Planora Badge */}
              <div 
                className="absolute left-3.5 bottom-3.5 w-10 h-10 rounded-full grid place-items-center"
                style={{ background: '#0a0f1e' }}
              >
                <svg viewBox="0 0 342 292" className="w-6 h-5" style={{ color: '#2563eb' }}>
                  <path fill="currentColor" d="M8 0 H237 C300 0 342 50 342 115 C342 195 275 262 192 262 H118 L127 209 H190 C243 209 290 165 290 115 C290 79 266 52 238 52 H14 C4 52 -1 46 1 38 Z"/>
                  <path fill="currentColor" d="M10 292 L45 128 C48 112 57 100 72 100 H217 L213 122 H110 Q106 122 106 126 Q106 130 110 130 H210 C206 142 198 152 186 152 H92 L61 292 Z"/>
                </svg>
              </div>
            </figure>
          </div>

          {/* Right Column - Content */}
          <div className="lg:w-1/2 flex flex-col gap-8 mt-8 lg:mt-0 max-w-[440px] mx-auto lg:mx-0 lg:max-w-none">
            
            {/* Name & Info */}
            <header className="flex flex-col gap-4">
              <div className="flex flex-col gap-1.5">
                <h1 
                  className="m-0 font-bold leading-none tracking-tight"
                  style={{ fontSize: 'clamp(36px, 5vw, 52px)', fontStretch: '116%', letterSpacing: '-0.005em' }}
                >
                  Nico Helfrich
                </h1>
                <div 
                  className="flex items-center gap-3"
                  style={{ 
                    fontFamily: '"IBM Plex Mono", ui-monospace, Menlo, Consolas, monospace',
                    fontSize: '11px',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    color: '#8a93a8'
                  }}
                >
                  <span>Ingenieur</span>
                  <span>·</span>
                  <span>Makler</span>
                  <span className="flex-1 h-px max-w-[100px] lg:max-w-[200px]" style={{ background: '#222c44' }}></span>
                </div>
              </div>

              {/* Claim */}
              <p 
                className="m-0 font-medium leading-tight"
                style={{ fontSize: 'clamp(20px, 3vw, 26px)', fontStretch: '106%', maxWidth: '24ch' }}
              >
                Ingenieurdenken<br />
                für deine<br />
                Finanzentscheidungen.
              </p>

              {/* Sub */}
              <p className="m-0" style={{ color: '#8a93a8', fontSize: '16px', maxWidth: '38ch' }}>
                Absicherung und Finanzplanung, nachvollziehbar gerechnet. Gründer von Planora Finance.
              </p>
            </header>

            {/* Quick Contact Buttons */}
            <div className="grid grid-cols-3 gap-2.5">
              {/* WhatsApp */}
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-1.5 py-3.5 px-1.5 rounded-xl text-center text-white no-underline transition-all hover:scale-105"
                style={{ 
                  border: '1px solid #222c44',
                  background: '#111829',
                  fontSize: '13px',
                  fontWeight: 500
                }}
                data-testid="contact-whatsapp"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{ color: '#25D366' }}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span>WhatsApp</span>
              </a>

              {/* Anrufen */}
              <a 
                href="tel:+4915233978878"
                className="flex flex-col items-center gap-1.5 py-3.5 px-1.5 rounded-xl text-center text-white no-underline transition-all hover:scale-105"
                style={{ 
                  border: '1px solid #222c44',
                  background: '#111829',
                  fontSize: '13px',
                  fontWeight: 500
                }}
                data-testid="contact-phone"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span>Anrufen</span>
              </a>

              {/* E-Mail */}
              <a 
                href="mailto:kontakt@nicohelfrich.de"
                className="flex flex-col items-center gap-1.5 py-3.5 px-1.5 rounded-xl text-center text-white no-underline transition-all hover:scale-105"
                style={{ 
                  border: '1px solid #222c44',
                  background: '#111829',
                  fontSize: '13px',
                  fontWeight: 500
                }}
                data-testid="contact-email"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="m22 7-10 6L2 7"/>
                </svg>
                <span>E-Mail</span>
              </a>
            </div>

            {/* Save Contact Button */}
            <button
              onClick={downloadVCard}
              className="w-full py-4 px-6 rounded-xl flex justify-center items-center gap-4 cursor-pointer transition-all hover:scale-[1.02] active:scale-[0.98]"
              style={{ 
                background: '#f2f4f8',
                color: '#0a0f1e',
                font: '600 16px/1.2 "Archivo", sans-serif',
                border: 0
              }}
              data-testid="save-contact-btn"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" style={{ color: '#5b6478' }}>
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                <polyline points="17 21 17 13 7 13 7 21"/>
                <polyline points="7 3 7 8 15 8"/>
              </svg>
              <span>Kontakt speichern</span>
              <span 
                style={{ 
                  fontFamily: '"IBM Plex Mono", monospace',
                  fontSize: '10px',
                  fontWeight: 500,
                  letterSpacing: '.08em',
                  textTransform: 'uppercase',
                  color: '#5b6478',
                  background: '#e2e5eb',
                  padding: '4px 8px',
                  borderRadius: '4px'
                }}
              >
                VCARD
              </span>
            </button>

            {/* Wie wir starten können */}
            <section className="flex flex-col gap-2.5">
              <div 
                style={{ 
                  fontFamily: '"IBM Plex Mono", monospace',
                  fontSize: '12px',
                  fontWeight: 500,
                  letterSpacing: '.14em',
                  textTransform: 'uppercase',
                  color: '#8a93a8'
                }}
              >
                Wie wir starten können
              </div>
              
              <div 
                className="flex flex-col rounded-xl overflow-hidden"
                style={{ border: '1px solid #222c44', background: '#111829' }}
              >
                {/* Der Finanzfahrplan */}
                <Link 
                  to="/strategiegespraech"
                  className="grid items-center gap-3.5 p-4 text-white no-underline transition-colors hover:bg-[#172036]"
                  style={{ gridTemplateColumns: 'auto 1fr auto' }}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-5 h-5" style={{ color: '#8a93a8' }}>
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                  </svg>
                  <div>
                    <strong className="block font-semibold text-base">Der Finanzfahrplan</strong>
                    <span className="block text-sm" style={{ color: '#8a93a8' }}>Kostenloses Erstgespräch vereinbaren</span>
                  </div>
                  <span style={{ color: '#8a93a8', fontFamily: '"IBM Plex Mono", monospace', fontSize: '14px' }}>→</span>
                </Link>

                {/* Absicherungscheck */}
                <Link 
                  to="/absicherungscheck"
                  className="grid items-center gap-3.5 p-4 text-white no-underline transition-colors hover:bg-[#172036]"
                  style={{ gridTemplateColumns: 'auto 1fr auto', borderTop: '1px solid #222c44' }}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-5 h-5" style={{ color: '#8a93a8' }}>
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    <path d="m9 12 2 2 4-4"/>
                  </svg>
                  <div>
                    <strong className="block font-semibold text-base">Absicherungscheck</strong>
                    <span className="block text-sm" style={{ color: '#8a93a8' }}>Lücken in deinen Versicherungen finden</span>
                  </div>
                  <span style={{ color: '#8a93a8', fontFamily: '"IBM Plex Mono", monospace', fontSize: '14px' }}>→</span>
                </Link>

                {/* Planora Finance */}
                <a 
                  href="https://planora.finance/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="grid items-center gap-3.5 p-4 text-white no-underline transition-colors hover:bg-[#172036]"
                  style={{ gridTemplateColumns: 'auto 1fr auto', borderTop: '1px solid #222c44' }}
                >
                  <svg viewBox="0 0 342 292" className="w-5 h-5" style={{ color: '#2563eb' }}>
                    <path fill="currentColor" d="M8 0 H237 C300 0 342 50 342 115 C342 195 275 262 192 262 H118 L127 209 H190 C243 209 290 165 290 115 C290 79 266 52 238 52 H14 C4 52 -1 46 1 38 Z"/>
                    <path fill="currentColor" d="M10 292 L45 128 C48 112 57 100 72 100 H217 L213 122 H110 Q106 122 106 126 Q106 130 110 130 H210 C206 142 198 152 186 152 H92 L61 292 Z"/>
                  </svg>
                  <div>
                    <strong className="block font-semibold text-base">Planora Finance</strong>
                    <span className="block text-sm" style={{ color: '#8a93a8' }}>Finanzplanung für echte Lebensentscheidungen</span>
                  </div>
                  <span style={{ color: '#8a93a8', fontFamily: '"IBM Plex Mono", monospace', fontSize: '14px' }}>→</span>
                </a>
              </div>
            </section>

            {/* Mehr von mir - Social Links */}
            <section className="flex flex-col gap-2.5">
              <div 
                style={{ 
                  fontFamily: '"IBM Plex Mono", monospace',
                  fontSize: '12px',
                  fontWeight: 500,
                  letterSpacing: '.14em',
                  textTransform: 'uppercase',
                  color: '#8a93a8'
                }}
              >
                Mehr von mir
              </div>
              
              <div className="flex gap-3 flex-wrap">
                {/* Instagram - Gradient Logo */}
                <a 
                  href="https://instagram.com/nico.hlf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full grid place-items-center no-underline transition-all hover:scale-110 hover:bg-[#172036]"
                  style={{ border: '1px solid #222c44', background: '#111829' }}
                  title="Instagram"
                >
                  <svg viewBox="0 0 24 24" className="w-6 h-6">
                    <defs>
                      <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#f09433"/>
                        <stop offset="25%" stopColor="#e6683c"/>
                        <stop offset="50%" stopColor="#dc2743"/>
                        <stop offset="75%" stopColor="#cc2366"/>
                        <stop offset="100%" stopColor="#bc1888"/>
                      </linearGradient>
                    </defs>
                    <path fill="url(#instagram-gradient)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>

                {/* YouTube - Red Logo */}
                <a 
                  href="https://www.youtube.com/@nico-planora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full grid place-items-center no-underline transition-all hover:scale-110 hover:bg-[#172036]"
                  style={{ border: '1px solid #222c44', background: '#111829' }}
                  title="YouTube"
                >
                  <svg viewBox="0 0 24 24" fill="#FF0000" className="w-6 h-6">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>

                {/* LinkedIn - Blue Logo with white letters */}
                <a 
                  href="https://www.linkedin.com/in/nicohelfrich"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full grid place-items-center no-underline transition-all hover:scale-110 hover:bg-[#172036]"
                  style={{ border: '1px solid #222c44', background: '#111829' }}
                  title="LinkedIn"
                >
                  <svg viewBox="0 0 24 24" className="w-6 h-6">
                    <rect width="24" height="24" rx="4" fill="#0A66C2"/>
                    <path fill="white" d="M7.5 8.5h-3v9h3v-9zm-1.5-1c1 0 1.5-.7 1.5-1.5s-.5-1.5-1.5-1.5-1.5.7-1.5 1.5.5 1.5 1.5 1.5zm12 10h-3v-4.5c0-1.2-.5-2-1.5-2s-1.5.8-1.5 2v4.5h-3v-9h3v1.2c.5-.8 1.3-1.5 2.5-1.5 2 0 3.5 1.3 3.5 4v5.3z"/>
                  </svg>
                </a>

                {/* Planora - Blue Logo */}
                <a 
                  href="https://planora.finance/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full grid place-items-center no-underline transition-all hover:scale-110 hover:bg-[#172036]"
                  style={{ border: '1px solid #222c44', background: '#111829' }}
                  title="Planora Finance"
                >
                  <svg viewBox="0 0 342 292" className="w-6 h-5" style={{ color: '#2563eb' }}>
                    <path fill="currentColor" d="M8 0 H237 C300 0 342 50 342 115 C342 195 275 262 192 262 H118 L127 209 H190 C243 209 290 165 290 115 C290 79 266 52 238 52 H14 C4 52 -1 46 1 38 Z"/>
                    <path fill="currentColor" d="M10 292 L45 128 C48 112 57 100 72 100 H217 L213 122 H110 Q106 122 106 126 Q106 130 110 130 H210 C206 142 198 152 186 152 H92 L61 292 Z"/>
                  </svg>
                </a>

                {/* NH Website */}
                <a 
                  href="https://nicohelfrich.de/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full grid place-items-center text-white no-underline transition-all hover:scale-110 hover:bg-[#172036]"
                  style={{ border: '1px solid #222c44', background: '#111829' }}
                  title="nicohelfrich.de"
                >
                  <span 
                    style={{ 
                      fontFamily: '"Archivo", sans-serif',
                      fontWeight: 700,
                      fontStretch: '116%',
                      fontSize: '15px',
                      letterSpacing: '.02em',
                      lineHeight: 1
                    }}
                  >
                    NH
                  </span>
                </a>
              </div>
            </section>

            {/* Footer - Legal Links */}
            <footer 
              className="flex gap-6 pt-4 border-t"
              style={{ 
                fontFamily: '"IBM Plex Mono", monospace', 
                fontSize: '12px',
                borderColor: '#222c44'
              }}
            >
              <Link to="/impressum" className="no-underline transition-colors hover:text-white" style={{ color: '#8a93a8' }}>
                Impressum
              </Link>
              <span style={{ color: '#222c44' }}>|</span>
              <Link to="/datenschutz" className="no-underline transition-colors hover:text-white" style={{ color: '#8a93a8' }}>
                Datenschutz
              </Link>
            </footer>

          </div>
        </div>
      </main>
    </div>
  );
};

export default Kontakt;
